import React from 'react';
import { PaginationItem, Stack } from '@mui/material';
import theme from '../../theme';

const Pagination = ({
  count,
  page,
  onChange,
  marginTop = { lg: '60px', md: '40px', xs: '30px' },
}) => {
  if (count <= 1) {
    return null;
  }

  const pageGroupSize = 10;
  const currentGroup = Math.ceil(page / pageGroupSize);

  const startPage = (currentGroup - 1) * pageGroupSize + 1;
  const endPage = Math.min(startPage + pageGroupSize - 1, count);

  const displayedPages = [];
  for (let i = startPage; i <= endPage; i++) {
    displayedPages.push(i);
  }

  const handlePageChange = (event, newPage) => {
    onChange(event, newPage);
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'auto',
      });
    };
    scrollToTop();
    setTimeout(scrollToTop, 50);
  };

  return (
    <Stack direction="row" justifyContent="center" sx={{ mt: marginTop }}>
      {/* 이전 버튼 */}
      <PaginationItem
        type="previous"
        onClick={(e) => handlePageChange(e, Math.max(page - 1, 1))}
        sx={{
          color: theme.palette.black[3],
          borderRadius: '2px',
          width: { xs: '28px', md: '32px' },
          height: { xs: '28px', md: '32px' },
          minWidth: { xs: '28px', md: '32px' },
          minHeight: { xs: '28px', md: '32px' },
          mr: '1px',
          ml: '0px',
          '& .MuiSvgIcon-root': {
            fontSize: { xs: '14px', md: '14px' },
          },
        }}
        shape="rounded"
      />

      {/* 페이지 번호들 (중간 생략 없음) */}
      {displayedPages.map((p) => (
        <PaginationItem
          key={p}
          page={p}
          selected={p === page}
          onClick={(e) => handlePageChange(e, p)}
          sx={{
            fontWeight: p === page ? 'bold' : 'regular',
            bgcolor: p === page ? theme.palette.grey.bg : 'transparent',
            color: p === page ? theme.palette.black[9] : theme.palette.black[4],
            borderRadius: '2px',
            fontSize: '14px',
            padding: { xs: '5px 4px', md: '9px 8px' },
            width: { xs: '28px', md: '32px' },
            height: { xs: '28px', md: '32px' },
            minWidth: { xs: '28px', md: '32px' },
            minHeight: { xs: '28px', md: '32px' },
            lineHeight: 1,
            mr: '1px',
            ml: '0px',
          }}
          shape="rounded"
        />
      ))}

      {/* 다음 버튼 */}
      <PaginationItem
        type="next"
        onClick={(e) => handlePageChange(e, Math.min(page + 1, count))}
        sx={{
          color: theme.palette.black[3],
          borderRadius: '2px',
          width: { xs: '28px', md: '32px' },
          height: { xs: '28px', md: '32px' },
          minWidth: { xs: '28px', md: '32px' },
          minHeight: { xs: '28px', md: '32px' },
          '& .MuiSvgIcon-root': {
            fontSize: { xs: '14px', md: '14px' },
          },
          mr: '1px',
          ml: '0px',
        }}
        shape="rounded"
      />
    </Stack>
  );
};

export default Pagination;
